import React,{useCallback} from 'react';
import {useSelector} from 'react-redux';

import {FormRow,FormColumn} from '~/components/InternalForm';
import PopUp from '~/components/PopUp';

import close from '~/assets/icons/close.svg';

export default function DeleteError({Open,Close,editor}) {
  const config = useSelector(state=>state.config.value);
  const handleDeleteError = useCallback(()=>{
    if(Open&&editor) Delete();
    function Delete(){
      var element = editor.selection.getNode();
      var pureText = document.createTextNode(element.textContent);
      element.parentNode.replaceChild(pureText, element);
      Close();
      editor.focus();
      editor.insertContent('');
      editor.nodeChanged();
    }
  },[Open,editor,Close]);
  return (
    <PopUp Tiny Open={Open} CallBack={Close}>
      <button type="button" onClick={Close}>
        <img src={close} alt={config.LANG['Close']} />
      </button>
      <h1>{config.LANG['Delete Error']}</h1>
      <br/><br/>
      <p>{config.LANG['Are you sure you want to delete this error?']}</p>
      <br/><br/>
      <FormRow>
        <FormColumn>
          <button className="add" type="button" onClick={handleDeleteError}>{config.LANG['YES']}</button>
        </FormColumn>
        <FormColumn>
          <button className="delete" type="button" onClick={Close}>{config.LANG['NO']}</button>
        </FormColumn>
      </FormRow>
    </PopUp>
  );
}